import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/GroupingsPreview/GroupingsPreview.tsx";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState, useCallback, memo } from 'react';
import { Groupings } from '@gmini/ui-kit/lib/Groupings/Groupings';
import { useElementPropertyList } from "../../helpers/useElementPropertyList";
import { emptyGroupingCondition } from "../../constants";
import { GroupingLayout } from "./GroupingsPreview.styled";
import { jsx as _jsx } from "react/jsx-runtime";
export var GroupingsPreview = /*#__PURE__*/memo(function (_ref) {
  var _ref$pending = _ref.pending,
      pending = _ref$pending === void 0 ? false : _ref$pending,
      groupingConditions = _ref.groupingConditions,
      onClick = _ref.onClick;

  var _useState = useState(groupingConditions),
      _useState2 = _slicedToArray(_useState, 2),
      groupingConditionsState = _useState2[0],
      setGroupingConditionsState = _useState2[1];

  useEffect(function () {
    setGroupingConditionsState((groupingConditions || [_objectSpread({}, emptyGroupingCondition)]).sort(function (a, b) {
      return a.order - b.order;
    }));
  }, [groupingConditions]);

  var _useElementPropertyLi = useElementPropertyList(),
      propertyList = _useElementPropertyLi.propertyElementList,
      listPending = _useElementPropertyLi.pending; // eslint-disable-next-line no-empty-function


  var onDeleteGrouping = useCallback(function () {}, []); // eslint-disable-next-line no-empty-function

  var addEmptyRow = useCallback(function () {}, []); // eslint-disable-next-line no-empty-function

  var onChangeProperty = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []); // eslint-disable-next-line no-empty-function

  var onRemoveRow = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), []);
  var getValue = useCallback(function (order) {
    var property = groupingConditionsState === null || groupingConditionsState === void 0 ? void 0 : groupingConditionsState.find(function (item) {
      return item.order === order;
    });

    if (!property) {
      return null;
    }

    return _objectSpread(_objectSpread({}, property), {}, {
      id: property.conditionElementPropertyId
    });
  }, [groupingConditionsState]);
  return /*#__PURE__*/_jsx(GroupingLayout, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Groupings, {
      propertyList: propertyList,
      pending: listPending || pending,
      onDeleteGrouping: onDeleteGrouping,
      onChangeProperty: onChangeProperty,
      disabled: false,
      onRemoveRow: onRemoveRow,
      groupingExists: !!(groupingConditions !== null && groupingConditions !== void 0 && groupingConditions.filter(function (_ref4) {
        var conditionElementPropertyId = _ref4.conditionElementPropertyId;
        return conditionElementPropertyId !== 0;
      }).length),
      addRow: addEmptyRow,
      emptyRows: groupingConditionsState.length <= 1,
      getValue: getValue,
      rowsCount: (groupingConditionsState === null || groupingConditionsState === void 0 ? void 0 : groupingConditionsState.length) || 0,
      notSelectedValue: !!(groupingConditionsState !== null && groupingConditionsState !== void 0 && groupingConditionsState.some(function (condition) {
        return condition.conditionElementPropertyId === 0;
      })),
      rowsLimit: 3,
      readOnly: true
    })
  });
});
GroupingsPreview.displayName = 'Groupings';